import React, {useEffect, useRef, useState} from 'react';
import {setDraggableCamId} from "../../../store/browse/actions";
import {childOf, elType, getCameraFromList} from "../../../utils";
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import useObjectFitElement from "../../../hooks/useObjectFitElement";
import { LayoutState } from '../../../store/layouts/types';
import useDragPane from '../../../hooks/useDragPane';

interface Props {
    src: string,
    pane: number,
    camID: string,
    visible: boolean,
    onLoad: () => void,
    onError: () => void,
}

const ThumbnailPaneComponent: React.FC<Props> = ({src, pane, camID, onLoad, onError, visible}) => {
    const dispatch = useDispatch();
    const ref = useRef<HTMLImageElement | null>(null);
    const {initialCameras} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const cam = camID ? getCameraFromList(Object.values(initialCameras), camID) : '';

    const [source, setSource] = useState<string | null>(src);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);

    const { onMouseMove, onDragLeave, fadeIn, onDragStart, onMouseDown } = useDragPane(ref, cam);

    useEffect(() => {
        if (ref.current) {
            ref.current.onload = () => {
                setIsLoaded(true);
                onLoad();
            };
            ref.current.onerror = () => {
                setIsLoaded(false);
                setTimeout(() => {
                    setSource(src + `&v=${Math.random() * 1000}`);
                }, 500);

                onError();
            }
        }
        return () => {
            if (ref.current) {
                ref.current.onload = null;
                ref.current.onerror = null;
            }
        }
    }, []);

    useObjectFitElement(ref);

    return (
        <img    src={source ? source : ''}
                alt="Thumbnail"
                className='thumbnail-pane'
                onMouseDown={onMouseDown}
                title={cam ? cam.name : ''}
                onDragStart={onDragStart}
                onDragEnd={fadeIn}
                onDragLeave={onDragLeave}
                onMouseMove={onMouseMove}
                ref={ref}
                id={`thumb-${pane}`}
                style={{
                    opacity: isLoaded ? 1 : 0
                }}
        />
    );
};
export default ThumbnailPaneComponent;